import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams, useLocation } from 'react-router-dom';
import { connect, useSelector, shallowEqual, useDispatch } from 'react-redux';
import swal from 'sweetalert';
import Label from '../../atoms/label/label';
import { IconType } from '../../atoms/icon/icon';
import Button, { ButtonTheme } from '../../atoms/button/button';
import Modal, { ModalSize } from '../../molecules/modal/modal';
import {
  getItems, createItem, removeItem, tableEdited, updateItems, getCatalog, getItemsPost,
} from '../../../store/externalCalls/api/secondaryListTableApi';
import TableSection from '../tableSection/tableSectionv2';
import { storeStructure } from '../../../store/reducers';
import { composeURL, checkObjectAttributes, getURLParams, appendParamsToURL } from '../../../utils/urlTools';
import InputText from '../../atoms/inputText/inputText';
import { getSortedItems } from '../../../store/externalCalls/api/listTableApi';
const FormInputRelationship = (props) => {
  const {
    additionalUpdates,
    dataSet,
    value,
    helpText,
    label,
    isForm,
    configFile,
    onChange,
    onCreate,
    blockInput,
    onDelete,
    onSave,
    name,
    type,
    validation,
    placeholder,
    configFileComposeExperience,
    defaultValue,
    pattern,
    popupSize,
    hasTooltip,
  } = props;
  const params = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const [openModal, setOpenModal] = useState(false);
  const [paginateValues, setPaginatedValues] = useState([]);
  const [updatedValues, setUpdateValues] = useState();
  const [errors, setErrors] = useState({});
  const session = useSelector((state) => state[storeStructure.Session], shallowEqual);
  const [itemsSelected, setItemsSelected] = useState(value);
  const id = configFile.idAttribute !== undefined
    ? params[configFile.idAttribute] : undefined;
  const [valueState, setValueState] = useState(value !== '' ? value : defaultValue);
  const [textState, setTextState] = useState();
  const [dataPaginated, setData] = useState(undefined);

  const childRef = useRef();
  const getData = (changePage,filters=null) => {
    
    if(configFile.getDataPostUrl)
    {
      let searchURL ='';
      console.log(configFile.getDataPostUrl)
      
      if(filters!=null)
      {
        searchURL = appendParamsToURL(configFile.getDataPostUrl, filters);
      }
      else
      {
        searchURL = configFile.getDataPostUrl;
      }
      const body = {
        items: dataSet,
        ...getURLParams(location.search),
      };
      
      getItemsPost(changePage || composeURL(session, configFile.sessionParams, searchURL), body)
        .then((paginatedItems) => {
          setPaginatedValues(paginatedItems);
          setData(paginatedItems);
          setOpenModal(true);
          setItemsSelected(itemsSelected);
        });
    }
    else {    
      if (checkObjectAttributes(session, configFile.sessionParams)) {
        getItems(changePage || composeURL(session, configFile.sessionParams, configFile.getURL))
          .then((paginatedItems) => {
            setPaginatedValues(paginatedItems);
            setData(paginatedItems);
            setOpenModal(true);
            setItemsSelected(itemsSelected);
          });
      }
    }
  };
  const handlerChangePage = (e) => {
    getData(e);
  };
  const handlerOpenModal = (item) => {
    
      getData();
    
  };

  const handlerErrors = (e) => {
    const messages = e.errors === undefined ? { general: 'Something was wrong' } : e.errors;

    setErrors(messages);
    setTimeout(() => {
      setErrors({});
    }, 5000);
  };


  const handlerCreate = (item) => {
    setErrors({});
    const url = composeURL(session, configFile.sessionParams, configFile.createURL, id);
    createItem(
      url,
      item,
      dispatch,
    ).then(() => {
      // eslint-disable-next-line max-len
      getItems(composeURL(session, configFile.sessionParams, configFile.getURL)).then((paginatedItems) => {
        setPaginatedValues(paginatedItems);
        setData(paginatedItems);
        setOpenModal(true);
        setItemsSelected(undefined);
      });
    }, (e) => {
      handlerErrors(e);
    });
  };
  const handlerRemoveItem = (item) => {
    swal({
      title: 'Are you sure?',
      text: 'You are removing a item.',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const url = composeURL(session, configFile.sessionParams, configFile.removeURL, id);
        removeItem(url, item, dispatch).then((result) => {
          getData();
          onDelete(result);
        }, (e) => {
          handlerErrors(e);
        });
      }
    });
  };
  const handlerUpdate = (dataSet) => {
    
    setUpdateValues(dataSet);
    if (configFile.autoUpdate === true) {
      const url = composeURL(session, configFile.sessionParams, configFile.updateURL, id);

      updateItems(url, dataSet, dispatch)
        .then(() => {
          onSave();
        }, (e) => {
          handlerErrors(e);
        });
    } else {
      tableEdited(dispatch);
    }
  };
  const handlerClickRow = (newItemSelected) => {
    setItemsSelected(newItemSelected);
  };

  const handlerCloseModal = (data) => {
    setOpenModal(false);
  };

  const handlerSave = () => {

    let copyUpdates = null;
    if(additionalUpdates)
    {      
      copyUpdates = JSON.parse(JSON.stringify(additionalUpdates))
      copyUpdates.map((update) => {
        update.relationshipField = itemsSelected[update.relationshipField];
      })
    }
    onChange({ target: { value: itemsSelected }}, copyUpdates );
    handlerCloseModal();
  };
  const handlerSort = (sort) => {
    const { attributeName, sortDown } = sort;
    const orderList = sortDown ? 'asc' : 'desc';
    const obj = {
      sort_by: attributeName,
      order: orderList,
    };
    const url = composeURL(session, configFile.sessionParams, configFile.getURL, id);
    const searchURL = appendParamsToURL(url, obj);
    getSortedItems(searchURL, dispatch);
  };

  const handlerSearch = (filters) => {

    if(configFile.getDataPostUrl)
    {
      getData(undefined,filters)
    }
    else{

      const searchURL = appendParamsToURL(configFile.getURL, filters);
      getCatalog(searchURL).then((response) => {
        console.log(response)
        setData(response);
      });
    }
  };

  useEffect(() => {
    childRef.current.updateValue(value);

    if (value !== '' && value !== valueState) {
      // textState ? handlerSaveUrl(value) : handlerSaveVodUrl(value);
      setValueState(value);
      childRef.current.updateValue(value);
    }
  }, [value]);

  return (
    <div className={isForm === true ? 'form-group row' : ''}>
      { label !== ''
        && (
          <Label helpText={helpText}>{label}</Label>
        )}
      <div className={ label === '' ? '':`${"col-sm-8"}` }>
        { !textState
          && (
            <InputText
              ref={childRef}
              name={name}
              type="text"
              blockInput={blockInput}
              className={(configFile || configFileComposeExperience) !== undefined ? 'form-input-text__input' : ''}
              validation={validation}
              placeholder={placeholder}
              value={valueState}
              onChange={onChange}
              pattern={pattern}
              hasTooltip={hasTooltip}
            />
            // <input
            //   name={name}
            //   id={name}
            //   type={type}
            //   className={`form-control border-${validation}  tes`}
            //   placeholder={placeholder}
            //   value={valueState}
            //   onChange={onChange}
            //   ref={childRef}
            //   onFocus={(e) => e.currentTarget.select()}
            // />
          )}
        { textState
          && (
            <InputText
              ref={childRef}
              name={name}
              type={type}
              blockInput={blockInput}
              className={(configFile || configFileComposeExperience) !== undefined ? 'form-input-text__input' : ''}
              validation={validation}
              placeholder={placeholder}
              value={valueState}
              onChange={onChange}
              pattern={pattern}
              hasTooltip={hasTooltip}
            />
          )}
  
        { textState
          && (
            <Button
              theme={ButtonTheme.PRIMARY}
              icon={IconType.NEW}
              onClick={handlerOpenModal}
              disabled
            />
          )}
        { !textState
          && (
            <Button
              theme={ButtonTheme.PRIMARY}
              icon={IconType.NEW}
              onClick={handlerOpenModal}
            />
          )}
      </div>
      { openModal === true
      && (
        <Modal
          title={configFile.title}
          onClose={handlerCloseModal}
          size={popupSize?popupSize:ModalSize.LARGE}
        >
          <TableSection
            configFile={configFile.tableConfig}
            valuesPaginated={dataPaginated}
            onChangePage={handlerChangePage}
            onClickRow={handlerClickRow}
            onChangeItem={handlerUpdate}
            onSearch={handlerSearch}
            onSort={handlerSort}
            onClickCreate={handlerCreate}
            onClickRemoveItem={handlerRemoveItem}
            initDataSelected={configFile.tableConfig.isMultiSelectable === true ? itemsSelected : itemsSelected}
          />
          <div>
            <Button
              theme={ButtonTheme.PRIMARY}
              onClick={handlerSave}
              disabled={itemsSelected === undefined}
            >
              Ok
            </Button>
          </div>
        </Modal>
      )}
    </div>
  );
};

FormInputRelationship.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.shape({}),
    PropTypes.any,
  ]),
  configFile: PropTypes.shape({
    itemId: PropTypes.string,
    getURL: PropTypes.string,
    itemName: PropTypes.string,
    createURL: PropTypes.string,
    removeURL: PropTypes.string,
    autoUpdate: PropTypes.bool,
    updateURL: PropTypes.string,
    idAttribute: PropTypes.string,
    title: PropTypes.string,
    sessionParams: PropTypes.arrayOf(PropTypes.string),
    tableConfig: PropTypes.shape({
      isMultiSelectable: PropTypes.bool,
    }),
  }).isRequired,
  onChange: PropTypes.func,
  onCreate: PropTypes.func,
  onDelete: PropTypes.func,
  onSave: PropTypes.func,
  isForm: PropTypes.bool,
  label: PropTypes.string,
  helpText: PropTypes.string,
  hasTooltip: PropTypes.bool,
};

FormInputRelationship.defaultProps = {
  label: '',
  helpText: '',
  value: [],
  popupSize:null,
  onChange: () => {},
  onCreate: () => {},
  onDelete: () => {},
  onSave: () => {},
  isForm: false,
  hasTooltip: false,
};

export default connect()(FormInputRelationship);
